import { render } from "./NavegacionIslero.vue?vue&type=template&id=1732bf17&scoped=true"
import script from "./NavegacionIslero.vue?vue&type=script&lang=js"
export * from "./NavegacionIslero.vue?vue&type=script&lang=js"

import "./NavegacionIslero.vue?vue&type=style&index=0&id=1732bf17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1732bf17"]])

export default __exports__